export enum GameIds {
    MegaKeno = 1501,
    MegaKeno2 = 1502,
    KenoMini = 1503,
    KenoMini2 = 1504,
    KenoEast = 1505,
    KenoWest = 1506,
    KenoSouth = 1507,
    KenoNorth = 1508,
    KenoPower = 1509,
    KenoPower2 = 1510,
    KenoSoccer = 1511,
    KenoSoccer2 = 1512,
} 
